import { useEffect, useRef, useState, useCallback } from "react";
import Lenis from "lenis";
import { Toaster } from "sonner";
import "@/App.css";
import { copy } from "@/data/i18n";
import Header from "@/components/Header";
import Hero from "@/components/Hero";
import Marquee from "@/components/Marquee";
import Chapters from "@/components/Chapters";
import Gallery from "@/components/Gallery";
import Location from "@/components/Location";
import Footer from "@/components/Footer";
import EnquiryModal from "@/components/EnquiryModal";

function App() {
  const lenisRef = useRef(null);
  const [enquiry, setEnquiry] = useState({ open: false, type: "stay" });
  const [lang, setLang] = useState("en");
  const t = copy[lang];

  useEffect(() => {
    const lenis = new Lenis({ duration: 1.25, smoothWheel: true });
    lenisRef.current = lenis;
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
    };
  }, []);

  useEffect(() => {
    if (enquiry.open) lenisRef.current?.stop();
    else lenisRef.current?.start();
  }, [enquiry.open]);

  const navigate = useCallback((id) => {
    if (id === "top") {
      lenisRef.current?.scrollTo(0, { duration: 1.4 });
      return;
    }
    const el = document.getElementById(id);
    if (el) lenisRef.current?.scrollTo(el, { offset: -70, duration: 1.4 });
  }, []);

  const openEnquiry = useCallback((type) => setEnquiry({ open: true, type }), []);
  const closeEnquiry = useCallback(() => setEnquiry((e) => ({ ...e, open: false })), []);
  const setEnquiryType = useCallback((type) => setEnquiry((e) => ({ ...e, type })), []);

  return (
    <div className="bg-ivory min-h-screen" data-testid="bron-menai-app">
      <div className="grain-overlay" />
      <Header t={t} lang={lang} onToggleLang={setLang} onNavigate={navigate} onEnquire={openEnquiry} />
      <main>
        <Hero t={t} onEnquire={openEnquiry} />
        <Marquee t={t} />
        <Chapters t={t} onEnquire={openEnquiry} />
        <Gallery t={t} />
        <Location t={t} />
      </main>
      <Footer t={t} onEnquire={openEnquiry} />
      <EnquiryModal t={t} open={enquiry.open} type={enquiry.type} onClose={closeEnquiry} onTypeChange={setEnquiryType} />
      <Toaster position="bottom-center" toastOptions={{ style: { background: "#1B3B36", color: "#FDFBF7", border: "none" } }} />
    </div>
  );
}

export default App;
